import { ui, define } from '@owenscorning/pcb.alpha';

export default ui`Text/Rich`({ tools: [ 'superscript', 'subscript', 'spacer', 'pink' ], inline: true });
